import DeliveryNote from './DeliveryNote'

export default DeliveryNote
